import React, { Fragment, useState, useEffect, useRef } from "react";
import ClipService from "../../../services/ClipService";
import PostService from "../../../services/PostService";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import CollectionModal from "../../modules/Collection/CollectionModal";
import {
  AWS_URL,
  REDUX_LOCAL_STORE_KEY,
} from "../../../components/config/constants";
import { CalendarDays, ImagePlus, Folder } from "lucide-react";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Loader from "../../../components/Loader";
import { getUserProfilePic } from "../../../components/helper/GeneralHelper";
import GeneralService from "../../../services/GeneralService";
import CollectionService from "../../../services/CollectionService";
import DefaultAvatar from "../../../components/common/DefaultAvatar.jsx";
import CustomDateTimePicker from "../../../components/common/CustomDateTimePicker.jsx";
import { CustomDatePicker } from "../../../components/common/CustomDatepicker.jsx";
import controlMediaSize from "../../../components/helper/ControlMedia";
import { useHistory } from "react-router-dom";

const UploadClip = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const clickInput = useRef(null);
  const clickThumbnail = useRef(null);

  const loggedUserInfo = props.loggedUserInfo;

  const [state, setState] = useState({
    showFilters: false,
    file: null,
    description: "",
    urlForUpload: "",
    uploadedMedia: "",
    uploadedMediaDataUrl: "",
    userId: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
      .authentication.userData._id,
    fileName: "",
    fileType: "",
    isClipFree: true,
    price: 0,
    discount: 0,
    schedule: false,
    dateClip: moment(moment().add(15, "minutes")),
    startDiscountDate: moment
      .utc()
      .locale(localStorage.getItem("i18nextLng")),
    startCalendarOpen: false,
    endDiscountDate: null,
    endCalendarOpen: false,
    myCategory: [],
    categoryList: [],
    thumbnail: "",
    thumbnailDataUrl: "",
    thumbnailFile: null,
    inputFileClip: null,
    inputEventClip: null,
    loading: false,
    blurredThumbNailImage: "",
    openVaultModal: false,
    isVaultMedia: false,
    minTime: moment(moment().add(15, "minutes")),
    allMedia: [],
  });

  const getAllCategory = () => {
    setState((prev) => ({ ...prev, loading: true }));
    GeneralService.getAllCategory()
      .then((res) => {
        setState((prev) => ({
          ...prev,
          categoryList: res.data.data,
          loading: false,
        }));
      })
      .catch(() => {});
  };

  const getAllMedias = () => {
    let params = {
      limit: 3,
      page: 0,
      mediaType: "video",
    };

    CollectionService.getAllCollection({ ...params })
      .then((res) => {
        setState((prev) => ({ ...prev, allMedia: res.data.data.mediasList }));
      })
      .catch(() => {
        setState((prev) => ({ ...prev, allMedia: [] }));
      });
  };

  useEffect(() => {
    getAllCategory();
    getAllMedias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const getVideoDuration = (file) => {
    return new Promise((resolve, reject) => {
      const videoElement = document.createElement("video");
      videoElement.style.display = "none";
      videoElement.onloadedmetadata = () => {
        const duration = videoElement.duration;
        videoElement.remove();
        resolve(duration);
      };

      videoElement.onerror = () => {
        videoElement.remove();
        reject("error");
      };
      videoElement.src = URL.createObjectURL(file);
    });
  };

  const putFile = (url, file, name) => {
    PostService.putFile(url, file)
      .then(() => {
        const newFileType =
          name.includes("jpeg") ||
          name.includes("png") ||
          name.includes("jpg")
            ? "image"
            : name.includes("mp4")
            ? "video"
            : "undefined";

        setState((prev) => ({
          ...prev,
          fileType: newFileType,
          uploadedMedia: name,
        }));

        // After state update, submit thumbnail
        // We use the current state values directly
        setState((prevState) => {
          if (prevState.thumbnailFile === null) {
            submitThumbnail(prevState.inputFileClip, false);
          } else {
            submitThumbnail(prevState.thumbnailFile, true);
          }
          return prevState;
        });
      })
      .catch(() => {});
  };

  const putFileThumbnail = (url, file, name) => {
    PostService.putFile(url, file)
      .then(() => {
        setState((prev) => ({
          ...prev,
          thumbnail: name,
        }));

        const img = new window.Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          ctx.filter = "blur(20px)";

          ctx.drawImage(img, 0, 0, img.width, img.height);
          try {
            canvas.toBlob(async (blob) => {
              const imageFile = new File([blob], "thumbnailBlur.jpg", {
                type: "image/jpeg",
              });

              let params2 = {
                folder: "thumbnailBlur",
                filename: `blurredThumbnail${new Date().getTime("L")}${
                  imageFile.name
                }`,
              };

              GeneralService.obtainUrlUpload({ ...params2 })
                .then((res) => {
                  PostService.putFile(res.data.data, imageFile)
                    .then(() => {
                      setState((prev) => ({
                        ...prev,
                        blurredThumbNailImage: params2.filename,
                      }));
                      // createClip will be called via effect or directly
                      createClipDirect(name, params2.filename);
                    })
                    .catch(() => {});
                })
                .catch(() => {});
            }, "image/jpeg");
          } catch (error) {
            console.error("Error converting canvas to Blob:", error);
          }
        };
      })
      .catch(() => {});
  };

  const createClipDirect = (thumbnailName, blurredName) => {
    // Read latest state
    setState((prev) => {
      const currentState = prev;
      if (currentState.price < 3 && currentState.isClipFree === false) {
        toast.error(t("clip.min1"));
        return prev;
      }
      if (currentState.uploadedMedia !== "") {
        if (
          currentState.fileType === "undefined" ||
          currentState.fileType === "image"
        ) {
          toast.error(t("clip.invalidFile"));
        } else {
          let params = {
            description: currentState.description,
            clipMedia: {
              isVaultMedia: currentState.isVaultMedia,
              name: currentState.uploadedMedia,
              thumbNailImage: thumbnailName || currentState.thumbnail,
              blurredThumbNailImage: blurredName || currentState.blurredThumbNailImage,
              type: currentState.fileType,
            },
            isFree: currentState.isClipFree,
            categoryIds: currentState.myCategory.map((value) => value._id),
            clipType: currentState.schedule ? "Scheduled" : "Normal",
            price: currentState.price === 0 ? undefined : currentState.price,
            discount: currentState.discount > 0 ? currentState.discount : 0,
            startDiscountDate:
              currentState.startDiscountDate !== null
                ? currentState.startDiscountDate
                : moment.utc().locale(localStorage.getItem("i18nextLng")),
            ...(currentState.endDiscountDate && {
              endDiscountDate: currentState.endDiscountDate,
            }),
            clipScheduledDateTime: currentState?.dateClip
              ? currentState.dateClip
              : null,
          };
          ClipService.createClip({ ...params })
            .then(() => {
              setState((p) => ({ ...p, loading: false }));
              toast.success(t("clip.clipCreated"));
              history.push("/");
            })
            .catch((err) => toast.error(err.message));
        }
      } else {
        toast.error(t("clip.selectVideo"));
      }
      return prev;
    });
  };

  const submitThumbnail = (file, isWithThumnnail) => {
    if (isWithThumnnail === false) {
      const url = URL.createObjectURL(file);
      const videoElement = document.createElement("video");
      videoElement.style.display = "none";
      videoElement.src = url;
      const onCanPlayThrough = async () => {
        videoElement.removeEventListener("canplaythrough", onCanPlayThrough);

        videoElement.currentTime = 0;

        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;

        const context = canvas.getContext("2d");

        const onSeeked = async () => {
          videoElement.removeEventListener("seeked", onSeeked);

          context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

          const DataUrl = canvas.toDataURL();
          setState((prev) => ({ ...prev, thumbnailDataUrl: DataUrl }));

          try {
            canvas.toBlob(async (blob) => {
              const imageFile = new File([blob], "thumbnail.jpg", {
                type: "image/jpeg",
              });

              let params = {
                folder: "thumbnail",
                filename: `${new Date().getTime("L")}${imageFile.name}`,
              };

              GeneralService.obtainUrlUpload({ ...params })
                .then((res) => {
                  putFileThumbnail(
                    res.data.data,
                    imageFile,
                    params.filename
                  );
                })
                .catch(() => {});
            }, "image/jpeg");
          } catch (error) {
            console.error("Error converting canvas to Blob:", error);
          }
        };

        videoElement.addEventListener("seeked", onSeeked);
        videoElement.currentTime = 0;
      };

      videoElement.addEventListener("canplaythrough", onCanPlayThrough);
    } else {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("_id", loggedUserInfo?.userData?._id);

      let params = {
        folder: "thumbnail",
        filename: `${new Date().getTime("L")}${file.name}`,
      };

      setState((prev) => ({
        ...prev,
        fileName: `${new Date().getTime("L")}${file.name}`,
      }));

      GeneralService.obtainUrlUpload({ ...params })
        .then((res) => {
          setState((prev) => ({
            ...prev,
            urlForUpload: res.data.data,
            file: formData,
          }));
          putFileThumbnail(
            res.data.data,
            file,
            params.filename
          );
        })
        .catch(() => {});
    }
  };

  const submitClip = async () => {
    if (state.price < 3 && state.isClipFree === false) {
      toast.error(t("clip.min1"));
      return;
    }

    if (state.myCategory.length === 0) {
      toast.error(t("category.selectCategory"));
      return;
    }

    if (state.isVaultMedia === true) {
      createClip();
    } else {
      setState((prev) => ({ ...prev, loading: true }));
      let file = state.inputFileClip;
      let event = state.inputEventClip;

      if (file) {
        const reader = new FileReader();

        reader.onload = (readerEvent) => {
          const dataURL = readerEvent.target.result;
          setState((prev) => ({ ...prev, uploadedMediaDataUrl: dataURL }));
        };

        reader.readAsDataURL(file);
      } else {
        toast.error(t("clip.invalidFile"));
        setState((prev) => ({ ...prev, loading: false }));
        return;
      }

      event.preventDefault();
      setState((prev) => ({ ...prev, fileType: "" }));
      if (
        file.name.includes("jpeg") ||
        file.name.includes("jpg") ||
        file.name.includes("png")
      ) {
        setState((prev) => ({ ...prev, fileType: "undefined" }));
        toast.error(t("clip.invalidFile"));
        setState((prev) => ({ ...prev, loading: false }));
      } else {
        const duration = await getVideoDuration(file);
        if (duration <= 60) {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("_id", loggedUserInfo?.userData?._id);
          let params = {
            folder: "media",
            filename: `${new Date().getTime("L")}${file.name}`,
          };

          GeneralService.obtainUrlUpload({ ...params })
            .then((res) => {
              setState((prev) => ({
                ...prev,
                urlForUpload: res.data.data,
                file: formData,
              }));
              putFile(res.data.data, file, params.filename);
            })
            .catch(() => {});
        } else {
          toast.error(t("clip.maxOneMinute"));
          setState((prev) => ({ ...prev, loading: false }));
        }
      }
    }
  };

  const creatPreviewClip = () => {
    let file = state.inputFileClip;

    if (file) {
      const reader = new FileReader();

      reader.onload = (readerEvent) => {
        const dataURL = readerEvent.target.result;
        setState((prev) => ({
          ...prev,
          uploadedMediaDataUrl: dataURL,
          uploadedMedia: "s",
          fileType: "video",
        }));
      };

      reader.readAsDataURL(file);
    }
  };

  const handleAddMedia = (medias) => {
    if (medias.length > 1 || !medias[0].type.includes("video")) {
      toast.error(t("clip.selectOnlyOneFile"));
    } else {
      const videoElement = document.createElement("video");
      videoElement.style.display = "none";
      videoElement.onloadedmetadata = () => {
        const duration = videoElement.duration;
        if (duration <= 60) {
          setState((prev) => ({
            ...prev,
            isVaultMedia: true,
            name: medias[0].name,
            thumbNailImage: medias[0].thumbNailImage,
            thumbnail: medias[0].thumbNailImage,
            blurredThumbNailImage: medias[0].blurredThumbNailImage,
            type: medias[0].type,
            fileType: medias[0].type,
            uploadedMediaDataUrl: medias[0].url,
            uploadedMedia: medias[0].name,
          }));
        } else {
          toast.error(t("clip.maxOneMinute"));
        }
        videoElement.remove();
      };

      videoElement.onerror = () => {
        videoElement.remove();
      };
      videoElement.src = medias[0].url;
    }
  };

  const updateCategory = (id) => {
    const categoryList = [...state.categoryList];
    const myCategory = [...state.myCategory];

    const indexInFilter = categoryList.findIndex((item) => item._id === id);
    const indexInMyCategory = myCategory.findIndex((item) => item._id === id);

    if (indexInFilter !== -1) {
      const removedItem = categoryList.splice(indexInFilter, 1)[0];
      setState((prev) => ({
        ...prev,
        myCategory: [...prev.myCategory, removedItem],
        categoryList: prev.categoryList.filter((item) => item._id !== id),
      }));
    } else if (indexInMyCategory !== -1) {
      const removedItem = myCategory.splice(indexInMyCategory, 1)[0];
      setState((prev) => ({
        ...prev,
        myCategory: prev.myCategory.filter((item) => item._id !== id),
        categoryList: [...prev.categoryList, removedItem],
      }));
    }
  };

  const handleChangePrice = (value) => {
    let sanitizedValue = value.replace(/[^0-9.,]/g, "");
    if (/^[0-9]*\.?[0-9]{0,2}$/.test(sanitizedValue)) {
      if (sanitizedValue <= 1000 && value >= 0) {
        setState((prev) => ({ ...prev, price: sanitizedValue }));
      } else {
        setState((prev) => ({ ...prev, price: 1000 }));
      }
    }
  };

  const handleDiscount = (value) => {
    let sanitizedValue = value.replace(/[^0-9]/g, "");
    if (/^[0-9]*\.?[0-9]{0,2}$/.test(sanitizedValue)) {
      if (sanitizedValue <= 100 && sanitizedValue >= 0) {
        setState((prev) => ({ ...prev, discount: sanitizedValue }));
      } else {
        setState((prev) => ({ ...prev, discount: 100 }));
      }
    }
  };

  const onDatePickerChange = (newDate) => {
    setState((prev) => ({
      ...prev,
      dateClip: newDate,
      minTime: calculateMinTime(newDate),
    }));
  };

  const calculateMinTime = (date) => {
    let isToday = moment(date).isSame(moment(), "day");
    if (isToday) {
      let nowAdd15min = moment(moment().add(15, "minutes"));
      return nowAdd15min;
    } else {
      return moment().startOf("day");
    }
  };

  const createClip = () => {
    if (state.price < 3 && state.isClipFree === false) {
      toast.error(t("clip.min1"));
    } else {
      if (state.uploadedMedia !== "") {
        if (
          state.fileType === "undefined" ||
          state.fileType === "image"
        ) {
          toast.error(t("clip.invalidFile"));
        } else {
          let params = {
            description: state.description,
            clipMedia: {
              isVaultMedia: state.isVaultMedia,
              name: state.uploadedMedia,
              thumbNailImage: state.thumbnail,
              blurredThumbNailImage: state.blurredThumbNailImage,
              type: state.fileType,
            },
            isFree: state.isClipFree,
            categoryIds: state.myCategory.map((value) => value._id),
            clipType: state.schedule ? "Scheduled" : "Normal",
            price: state.price === 0 ? undefined : state.price,
            discount: state.discount > 0 ? state.discount : 0,
            startDiscountDate:
              state.startDiscountDate !== null
                ? state.startDiscountDate
                : moment.utc().locale(localStorage.getItem("i18nextLng")),
            ...(state.endDiscountDate && {
              endDiscountDate: state.endDiscountDate,
            }),
            clipScheduledDateTime: state?.dateClip
              ? state.dateClip
              : null,
          };
          ClipService.createClip({ ...params })
            .then(() => {
              setState((prev) => ({ ...prev, loading: false }));
              toast.success(t("clip.clipCreated"));
              history.push("/");
            })
            .catch((err) => toast.error(err.message));
        }
      } else {
        toast.error(t("clip.selectVideo"));
      }
    }
  };

  const submitCustomThumbnailWithout = (file, event) => {
    event.preventDefault();
    if (
      file.name.includes(".jpeg") ||
      file.name.includes(".jpg") ||
      file.name.includes(".png")
    ) {
      setState((prev) => ({
        ...prev,
        fileName: `${new Date().getTime("L")}${file.name}`,
        thumbnailFile: file,
      }));

      if (file) {
        const reader = new FileReader();

        reader.onload = (readerEvent) => {
          const dataURL = readerEvent.target.result;
          setState((prev) => ({ ...prev, thumbnailDataUrl: dataURL }));
        };

        reader.readAsDataURL(file);
      }
    } else {
      toast.error(t("clip.invalidFile"));
    }
  };

  const width = window.innerWidth;
  const userId = JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
    .authentication.userData._id;
  const profilePicture = JSON.parse(
    localStorage.getItem(REDUX_LOCAL_STORE_KEY)
  ).authentication.userData.profilePicture;

  const name = JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
    .authentication.userData.name;

  var isMobile = width <= 512;
  var isTab = width <= 992;

  return (
    <Fragment>
      {state.loading ? <Loader /> : null}
      <div
        style={
          isMobile
            ? { paddingLeft: "20px", paddingRight: "20px", paddingTop: "8px" }
            : {}
        }
        className="right-chat-active"
      >
        <div
          className={`${isMobile || isTab ? " mb-5" : ""} ${
            isTab === true
              ? "middle-sidebar-bottom"
              : "fix-content-subscription clip-page"
          }`}
        >
          <div className="mb-16px">
            <span
              className="clip-pre-url hover"
              onClick={() => history.push("/clips")}
            >
              {t("clip.clips")}{" "}
            </span>
            <span className="text-12px t-black darktheme-txt">
              {"/ "}
              {t("clip.uploadClip")}
            </span>
          </div>

          <div
            onDrop={(event) => {
              setState((prev) => ({
                ...prev,
                inputFileClip: event.dataTransfer.files[0],
                inputEventClip: event,
              }));
              // Use setTimeout to allow state to update, then preview
              setTimeout(() => creatPreviewClip(), 0);
            }}
            onDragOver={(event) => handleDragOver(event)}
            className="card w-100 clip-container no-border-down"
          >
            <input
              onChange={async (event) => {
                const controlledFile = await controlMediaSize(
                  [{ file: event.target.files[0] }],
                  t
                );
                if (controlledFile) {
                  setState((prev) => ({
                    ...prev,
                    inputFileClip: event.target.files[0],
                    inputEventClip: event,
                  }));
                  // Use setTimeout to allow state to update, then preview
                  setTimeout(() => creatPreviewClip(), 0);
                }
              }}
              type="file"
              accept="video/mp4,video/quicktime"
              ref={clickInput}
              style={{ display: "none" }}
            ></input>
            <div className="card-body p-0 mt-3">
              <div className="absolute-center">
                {state.uploadedMedia === "" ? (
                  <img
                    src={`${AWS_URL}logo/upload_placeholder.png`}
                    height={80}
                    width={80}
                    alt=""
                  ></img>
                ) : (
                  <>
                    {state.fileType.includes("video") && (
                      <video
                        controlsList="nodownload nocontextmenu noremoteplayback"
                        oncontextmenu="return false;"
                        className="br-8px w-100 mh-332px"
                        width={"100%"}
                        controls
                      >
                        <source
                          src={state.uploadedMediaDataUrl}
                          type="video/mp4"
                        />
                      </video>
                    )}
                    {(state.fileType.includes("undefined") ||
                      state.fileType.includes("image")) && (
                      <div>{t("clip.notValid")}</div>
                    )}
                  </>
                )}
              </div>
              {state.uploadedMedia === "" ? (
                <div className="absolute-center upload-media-text">
                  {t("clip.uploadMedia")}
                </div>
              ) : null}
              {isMobile === false ? (
                <>
                  {state.uploadedMedia === "" && (
                    <>
                      <div className="absolute-center wallet-info">
                        {t("clip.dragAndDrop")}
                      </div>
                      <div className="absolute-center wallet-info">
                        {t("clip.or")}
                      </div>
                    </>
                  )}
                </>
              ) : null}
              <div
                onClick={() => clickInput.current.click()}
                className="absolute-center clip-browse hover"
              >
                {t("clip.browseMedia")}
              </div>
            </div>
          </div>
          <div className="select-clip-from-collection clip-data">
            <span>{t("clip.orSelectCollection")}</span>
            <div className="preview-clip-medias">
              {state.allMedia.map((media, index) => (
                <div
                  className="preview-clip-media pointer"
                  style={{ backgroundPosition: "cover" }}
                  onClick={() => {
                    setState((prev) => ({ ...prev, openVaultModal: true }));
                  }}
                >
                  <img
                    alt=""
                    className="image-colletion"
                    src={media.thumbnailUrl}
                  />
                </div>
              ))}
              <div
                className="preview-clip-open-collections pointer"
                onClick={() => {
                  setState((prev) => ({ ...prev, openVaultModal: true }));
                }}
              >
                <Folder size={20} />
                <span>{t("clip.openCollection")}</span>
              </div>
            </div>
          </div>
          <div className="select-category-for-clip clip-data">
            <div className="select-category-clip">
              {t("clip.selectCategory")}
            </div>
            <div>
              <div className="col-12 mt-1">
                <div className="stripe-input rounded-pill p-2">
                  <select
                    value={t("clip.selectCategory")}
                    onChange={(value) =>
                      updateCategory(value.target.value)
                    }
                    className={`border-0 bg-payment-white font-dark font-xsss ms-1 w-95 text-color-dark bgc-white`}
                  >
                    <option>{t("category.selectCategory")}</option>

                    {state.categoryList.map((value, index) => (
                      <option value={value._id}>
                        {t(`category.${value.categoryName}`)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <br></br>

            {state.myCategory.map((value, index) => (
              <Button className="align-center fix-buttom p-0 btn p-2 lh-24 w125 ms-1 ls-3 d-inline-block rounded-xl subscriptionSubscibe border-red detailTitle fw-700 ls-lg text-white">
                {t(`category.${value.categoryName}`)}
                <span
                  onClick={() => updateCategory(value._id)}
                  className="card-money-left"
                >
                  <i className="feather-trash-2 font-xs  text-white Subscription-text"></i>
                </span>
              </Button>
            ))}

            <div className="select-category-clip">
              {t("clip.contentType")}
            </div>
            <div className="flex-paginator">
              <span>
                <button
                  onClick={() => setState((prev) => ({ ...prev, isClipFree: true }))}
                  className={`${
                    state.isClipFree
                      ? "button-advance-upload-clip-active"
                      : "button-advance-upload-clip-inactive"
                  }`}
                >
                  {t("clip.freeContent")}
                </button>
              </span>
              <span>
                <button
                  onClick={() => setState((prev) => ({ ...prev, isClipFree: false }))}
                  className={`${
                    state.isClipFree
                      ? "button-advance-upload-clip-inactive"
                      : "button-advance-upload-clip-active"
                  }`}
                >
                  {t("clip.paidContent")}
                </button>
              </span>
            </div>
            {state.isClipFree === false && (
              <div>
                <div className="select-category-clip mt-16px">
                  {t("account.price")}
                </div>
                <div className="mt-4px">
                  <div className="form-group mb-1 add-card-modal">
                    <div className="flex-paginator align-center relative">
                      <div className="w-100 form-group icon-tab bg-payment-white rounded-3 mb-1">
                        <div style={{ display: "flex", width: "100%" }}>
                          <div
                            style={{
                              alignItems: "center",
                              display: "flex",
                              width: "0px",
                              position: "relative",
                              left: "10px",
                            }}
                            className="wallet-url-text"
                          >
                            $
                          </div>
                          <input
                            onChange={(value) =>
                              handleChangePrice(value.target.value)
                            }
                            value={state.price}
                            type="number"
                            max={1000}
                            min={1}
                            className="modal-input rounded-pill px-4 py-2"
                            placeholder={t("clip.enterPrice")}
                          />
                        </div>
                        <div
                          style={{
                            textAlignLast: "left",
                            marginTop: "4px",
                          }}
                          className="text-min-price-chat"
                        >
                          {t("chat.minPrice3")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${isMobile ? "" : "flex-paginator"} `}>
                  <div
                    className={`${
                      isMobile ? "w-100" : "w-50 mr-8px"
                    } form-group mb-1 add-card-modal`}
                  >
                    <div className="flex-paginator align-center relative">
                      <div className="w-100 form-group icon-tab bg-payment-white rounded-3 mb-1">
                        <div className="select-category-clip mb-1">
                          {t("clip.discount")}
                        </div>
                        <div style={{ display: "flex" }}>
                          <input
                            onChange={(value) =>
                              handleDiscount(value.target.value)
                            }
                            value={state.discount}
                            type="number"
                            max={100}
                            min={1}
                            className="modal-input rounded-pill px-4 py-2"
                            placeholder={t("clip.enterPrice")}
                          />
                          <div
                            style={{
                              alignItems: "center",
                              display: "flex",
                              width: "0px",
                              position: "relative",
                              right: "25px",
                            }}
                            className="wallet-url-text"
                          >
                            %
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${
                      isMobile ? "w-100" : " w-50 mr-8px"
                    } d-block`}
                  >
                    <div className="select-category-clip mb-1">
                      {t("clip.startDiscountDate")}
                    </div>
                    <div className="calendar-update-clip">
                      <CustomDatePicker
                        date={state.startDiscountDate}
                        onDatePickerChange={(value) =>
                          setState((prev) => ({
                            ...prev,
                            startDiscountDate: moment
                              .utc(value)
                              .locale(localStorage.getItem("i18nextLng")),
                            endDiscountDate: moment
                              .utc(value)
                              .locale(localStorage.getItem("i18nextLng"))
                              .isAfter(prev.endDiscountDate)
                              ? moment
                                  .utc(value)
                                  .locale(localStorage.getItem("i18nextLng"))
                              : prev.endDiscountDate,
                          }))
                        }
                        minDate={moment
                          .utc()
                          .locale(localStorage.getItem("i18nextLng"))}
                        minTime={moment
                          .utc(state.minTime)
                          .locale(localStorage.getItem("i18nextLng"))}
                      />
                    </div>
                  </div>
                  <div className={`${isMobile ? "w-100" : " w-50"} d-block`}>
                    <div className="select-category-clip  mb-1">
                      {t("clip.endDiscountDate")}
                    </div>
                    <div className="calendar-update-clip">
                      <CustomDatePicker
                        date={state.endDiscountDate}
                        onDatePickerChange={(value) =>
                          setState((prev) => ({
                            ...prev,
                            endDiscountDate: moment
                              .utc(value)
                              .locale(localStorage.getItem("i18nextLng")),
                          }))
                        }
                        minDate={state.startDiscountDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <br></br>
            <div className="advanced-title">
              {t("queue.advancedSettings")}
            </div>
            <div className="advance-icon-update-clip d-flex-block">
              <div
                onClick={() =>
                  setState((prev) => ({ ...prev, schedule: !prev.schedule }))
                }
                className={`${
                  isMobile && "mb-2"
                }  icon-upload-clip-calendar hover`}
              >
                <div className="d-flex align-items-center">
                  <CalendarDays
                    size={16}
                    style={{ marginRight: "4px" }}
                  />
                  <span className="advance-upload-clip-text">
                    {t("clip.schedulePublish")}
                  </span>
                </div>
              </div>
              <div
                onClick={() => clickThumbnail.current.click()}
                className={`${
                  !isMobile && "mx-2"
                }  icon-upload-clip-thumbnail hover`}
              >
                <div className="d-flex align-items-center">
                  <ImagePlus
                    size={16}
                    style={{ marginRight: "4px" }}
                  />
                  <span className="advance-upload-clip-text">
                    {t("clip.customThumbnail")}
                  </span>
                </div>
              </div>
              <input
                onChange={async (event) => {
                  const controlledFile = await controlMediaSize(
                    [{ file: event.target.files[0] }],
                    t
                  );
                  if (controlledFile) {
                    submitCustomThumbnailWithout(
                      event.target.files[0],
                      event
                    );
                  }
                }}
                className="display-none"
                type="file"
                accept="image/jpeg,image/jpg,image/png,image/heic,image/heif"
                ref={clickThumbnail}
              ></input>
            </div>
            {state.thumbnailDataUrl && (
              <img
                className="br-8px"
                width={"100%"}
                src={state.thumbnailDataUrl}
                alt="Thumbnail"
              ></img>
            )}
            {state.schedule && (
              <div className="w-sm-50 m-auto scheduleInputtype border-clip-schedule">
                <CustomDateTimePicker
                  date={state.dateClip}
                  minTime={state.minTime}
                  onDatePickerChange={(newDate) =>
                    onDatePickerChange(newDate)
                  }
                />
              </div>
            )}
          </div>
          <div className="clip-what clip-data">
            <div
              className="flex-paginator align-items-center"
              style={{ gap: "10px" }}
            >
              <span>
                <DefaultAvatar
                  id={userId}
                  height={"32px"}
                  width={"32px"}
                  userName={name}
                >
                  {profilePicture ? (
                    <img
                      src={getUserProfilePic(userId, profilePicture)}
                      className="border-radius-40"
                      width={32}
                      height={32}
                      alt={name}
                      title={name}
                    ></img>
                  ) : null}
                </DefaultAvatar>
              </span>
              <input
                placeholder={t("clip.mind")}
                className="special-input-clip w-100"
                value={state.description}
                onChange={(value) =>
                  setState((prev) => ({ ...prev, description: value.target.value }))
                }
              ></input>
            </div>
            {!isMobile && (
              <div className="button-upload-clip">
                <Button
                  onClick={() => submitClip()}
                  className="align-center fix-buttom p-0 btn p-2 lh-24 w125 ms-1 ls-3 d-inline-block rounded-xl subscriptionSubscibe border-red fw-700 ls-lg text-white"
                >
                  {t("clip.uploadClip")}
                </Button>
              </div>
            )}
          </div>
        </div>
        {isMobile && (
          <div style={{ padding: "0px 16px 26px" }} className="w-100">
            <Button
              onClick={() => submitClip()}
              className="w-100 align-center p-0 btn p-2 lh-24 w125 ls-3 d-inline-block rounded-xl subscriptionSubscibe border-red fw-700 ls-lg text-white"
            >
              {t("clip.uploadClip")}
            </Button>
          </div>
        )}
      </div>
      <CollectionModal
        showCollectionModal={state.openVaultModal}
        handleCloseModal={() => setState((prev) => ({ ...prev, openVaultModal: false }))}
        handleAddMedia={(medias) => handleAddMedia(medias)}
        selectedMediaType={"video"}
        hideAllMedia={true}
        hideImages={true}
        hideAudios={true}
        hideVr={true}
      />
    </Fragment>
  );
};

export default UploadClip;
